define('shared/util/Domain',[
    'shared/page/market',
    'node_modules/@ef/b2c-client-util-domain/src/Domain'
], function (
    getMarket,
    Domain
) {
    'use strict';

    Domain.config.getMarket = getMarket;

    return Domain;
});

